import React, {Component} from 'react';
import {Row, Col, Button} from 'react-bootstrap';
import Scrollchor from 'react-scrollchor';

//CSS
import '../LandingSubcomponents/QuienesSomos.css';


class MapaClientes extends Component {

    render() {

        return (
            <div>
                <Row className="entregas">
                    <Col md={6} sm={12} xs={12} className="wow animated bounceInLeft"
                         data-wow-duration="1s">
                        <Row>
                            <Col md={7} sm={12} xs={12}
                                 className="entregas-descripcion wow animated bounceInLeft" data-wow-duration="1s">
                                <h3 style={{color:"red", textShadow:"none"}}>¡Ya somos 5000!</h3>
                                <h4>Contamos con una gran variedad de comercios que nos eligen cada día. Cliente como
                                    Autoservicios, Almacenes, kioscos, bares, dietéticas y más... ¿Te gustaría contar
                                    con nuestro servicio? ¡Escribinos! </h4>
                                <a href="http://carrito.myfdistribuciones.com.ar/sk2.myf/registro.php" target="_blank">
                                    <Scrollchor to="#contacto">
                                        <Button className="btn-primary"
                                                style={{
                                                    padding: "5px 15px",
                                                    marginTop: "15px",
                                                    outline: "none",
                                                    marginBottom: "25px"
                                                }}>
                                            Enviar mensaje
                                        </Button>
                                    </Scrollchor>
                                </a>
                            </Col>
                        </Row>

                    </Col>
                    <Col md={6} sm={12} xs={12} id="mapa" style={{height: "100%", padding: "0"}}>
                        <div className="map-responsive" style={{height:"450px"}}></div>
                    </Col>
                </Row>
            </div>
        );
    }
}


export default MapaClientes;


// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingSubcomponents/MapaClientes.js